import { useForm } from "react-hook-form";
import { baseURL } from '../config/config';
import { post } from "../utils/apiManager";
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from "react";

const EyeIcon = ({ show }) => (
  <span style={{ fontSize: 16, lineHeight: 1 }}>
    {show ? "🙈" : "👁️"}
  </span>
);

const NewPassword = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const Navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  useEffect(() => { if (!id) Navigate("/auth/forgot-password"); }, [id]);

  const onSubmit = (data) => {
    if (data.newPassword !== data.oldPassword) return toast.error("Passwords do not match");
    if (String(data.newPassword || '').length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    // Only checks the reset link is still valid; the new password is passed to the next
    // screen in memory, never in the address bar
    post(`${baseURL}/admin/reset-password`, { validateString: id }).then((res) => {
      setLoading(false);
      if (res?.status) {
        toast.success(res.message);
        Navigate(`/auth/forgot-password-otp/${id}`, { state: { password: data.newPassword } });
      }
      else toast.error(res?.message);
    }).catch((err) => { setLoading(false); toast.error(err?.response?.data?.error); });
  };

  const inputS = (err) => ({ width: '100%', padding: '11px 40px 11px 14px', borderRadius: 9, border: `1.5px solid ${err ? '#AD2429' : '#e2e8f0'}`, fontSize: 14, color: '#0a1628', outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' });

  return (
    <div style={{ width: '100%', maxWidth: 420, fontFamily: "'Segoe UI', system-ui, sans-serif" }}>
      <div style={{ background: '#fff', borderRadius: 16, boxShadow: '0 8px 32px rgba(26,39,68,.12)', overflow: 'hidden', padding: '40px 36px' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ width: 52, height: 52, borderRadius: 14, background: '#fee2e2', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 24, margin: '0 auto 14px' }}>🔑</div>
          <h2 style={{ fontSize: 22, fontWeight: 700, color: '#0a1628', margin: '0 0 6px', letterSpacing: '-0.5px' }}>Set New Password</h2>
          <p style={{ fontSize: 14, color: '#9aa5c0', margin: 0 }}>Enter and confirm your new password</p>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div style={{ marginBottom: 16 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>New Password</label>
            <div style={{ position: 'relative' }}>
              <input placeholder="New Password" type={showOldPassword ? "text" : "password"} style={inputS(errors.oldPassword)} {...register("oldPassword", { required: true })} />
              <button
                type="button"
                onClick={() => setShowOldPassword(!showOldPassword)}
                style={{
                  position: 'absolute',
                  right: 12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <EyeIcon show={showOldPassword} />
              </button>
            </div>
            {errors.oldPassword && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
          </div>
          <div style={{ marginBottom: 24 }}>
            <label style={{ fontSize: 13, fontWeight: 600, color: '#3a4a6a', marginBottom: 6, display: 'block' }}>Confirm Password</label>
            <div style={{ position: 'relative' }}>
              <input placeholder="Confirm Password" type={showNewPassword ? "text" : "password"} style={inputS(errors.newPassword)} {...register("newPassword", { required: true })} />
              <button
                type="button"
                onClick={() => setShowNewPassword(!showNewPassword)}
                style={{
                  position: 'absolute',
                  right: 12,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <EyeIcon show={showNewPassword} />
              </button>
            </div>
            {errors.newPassword && <span style={{ fontSize: 12, color: '#AD2429', marginTop: 4, display: 'block' }}>Required</span>}
          </div>
          <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: '#AD2429', color: '#fff', border: 'none', borderRadius: 9, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit', opacity: loading ? 0.7 : 1 }}>
            {loading ? 'Saving...' : 'Set Password'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewPassword;
